<template>
  <div class="page">
    <SigninForm />
  </div>
</template>

<route lang="json">
{ "name": "accounts-signin" }
</route>

<script setup lang="ts">
import SigninForm from "@/components/profile/SigninForm.vue";
import { useUserStore } from "@/stores/user";
import { useHead } from "@unhead/vue";
import { onMounted } from "vue";
import { useRouter } from "vue-router";

const user = useUserStore();
const router = useRouter();

useHead({
  title: "Sign In",
});

onMounted(() => {
  if (user.props.id) {
    router.push({ name: "accounts-profile" });
  }
});
</script>

<style scoped></style>
